/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessCollectionPayerResponseItem } from '../models/SuccessCollectionPayerResponseItem';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PayerPartnerControllerService {

    /**
     * Returns a list of health plan payers
     * @returns SuccessCollectionPayerResponseItem OK
     * @throws ApiError
     */
    public static providePayerList(): CancelablePromise<SuccessCollectionPayerResponseItem> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/partners/payers',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
